





















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'BaseLoaderCircular',
})
export default class LoaderCircular extends Vue {
  @Prop({ default: 40 }) size?: number;

  get width(): string {
    return `${this.size}px`;
  }

  get height(): string {
    return `${this.size}px`;
  }
}
